import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.167 9.417a.75.75 0 0 1 .75.75v5.958a.75.75 0 0 1-1.5 0v-5.958a.75.75 0 0 1 .75-.75M13.833 9.417a.75.75 0 0 1 .75.75v5.958a.75.75 0 0 1-1.5 0v-5.958a.75.75 0 0 1 .75-.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.84 2.083a.75.75 0 0 0-.657.39L7.89 4.832H2.833a.75.75 0 1 0 0 1.5h1.542v14.833c0 .415.336.75.75.75h13.75a.75.75 0 0 0 .75-.75V6.333h1.542a.75.75 0 1 0 0-1.5h-5.052L14.85 2.478a.75.75 0 0 0-.66-.395zm4.572 2.75-.671-1.25h-3.456L9.6 4.833zm-6.079 1.5H5.875v14.083h12.25V6.333H8.333",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }